import React from "react";
import { useTranslation } from "react-i18next";

import "./ShopPage.css";
import { IMAGES } from "../utils/GetImages";
import { getTranslation } from "../utils/translation";
import { getPDFUrls } from "../utils/config";

export default function ShopPage() {
  const { i18n } = useTranslation();
  const pdfUrls = getPDFUrls();

  const Product1Img = IMAGES["ShopPage-Product1.png"];
  const Product2Img = IMAGES["ShopPage-Product2.png"];
  const Product3Img = IMAGES["ShopPage-Product3.png"];
  const Product4Img = IMAGES["ShopPage-Product4.png"];

  return (
    <div className="shop-page-background">
      <div className="shop-page-container">
        <h2 className="shop-page-title">
          {getTranslation(i18n, "shopPage.pageTitle")}
        </h2>
        <section id="products">
          <div className="product-card">
            <img
              src={Product1Img}
              alt="App Preview"
              className="product-card-image"
            />
            <div className="product-card-content">
              <h2>{getTranslation(i18n, "shopPage.product1.title")}</h2>
              <p>{getTranslation(i18n, "shopPage.product1.description")}</p>
              <p className="product-card-content-price">
                {getTranslation(i18n, "shopPage.product1.price")}
              </p>
            </div>
          </div>
          <div className="product-card reverse">
            <img
              src={Product2Img}
              alt="App Preview"
              className="product-card-image"
            />
            <div className="product-card-content">
              <h2>{getTranslation(i18n, "shopPage.product2.title")}</h2>
              <p>{getTranslation(i18n, "shopPage.product2.description")}</p>
              <p className="product-card-content-price">
                {getTranslation(i18n, "shopPage.product2.price")}
              </p>
            </div>
          </div>
          <div className="product-card">
            <img
              src={Product3Img}
              alt="App Preview"
              className="product-card-image"
            />
            <div className="product-card-content">
              <h2>{getTranslation(i18n, "shopPage.product3.title")}</h2>
              <p>{getTranslation(i18n, "shopPage.product3.description")}</p>

              <p className="product-card-content-price">
                {getTranslation(i18n, "shopPage.product3.price")}
              </p>
            </div>
          </div>
          <div className="product-card reverse">
            <img
              src={Product4Img}
              alt="App Preview"
              className="product-card-image"
            />
            <div className="product-card-content">
              <h2>{getTranslation(i18n, "shopPage.product4.title")}</h2>
              <p>{getTranslation(i18n, "shopPage.product4.description")}</p>
              <p className="product-card-content-price">
                {getTranslation(i18n, "shopPage.product4.price")}
              </p>
            </div>
          </div>
        </section>

        {/* PDF View More Section */}
        {pdfUrls.onlineShop && (
          <div className="pdf-view-more-section">
            <div className="pdf-view-more-content">
              <h3 className="pdf-view-more-title">
                {getTranslation(i18n, "shopPage.viewMore") || "View More"}
              </h3>
              <p className="pdf-view-more-description">
                {getTranslation(i18n, "shopPage.viewMoreDescription") ||
                  "Download our online shop catalog for more products and details"}
              </p>
              <a
                href={pdfUrls.onlineShop}
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-view-more-button"
              >
                🛍️{" "}
                {getTranslation(i18n, "shopPage.downloadCatalog") ||
                  "Download Catalog"}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
